import React, { useEffect, useState } from "react";
import { Slide, Button, Box } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import * as APIStore from "../store/APIStore";
import { Reply, Forward, Delete, Send, Cancel } from "@material-ui/icons";
import ConfirmDialog from "./ConfirmDialog";
import { useHistory, useParams } from "react-router-dom";
import moment from 'moment';
import RequestAccessToken from '../util/authService';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import NotificationPatient from './notification/NotificationPatient'
import { DetailedPatientStateType } from './notification/MessagePatientLoadState';
import './style.css';
import Hidden from '@material-ui/core/Hidden';
import MessageAttachment from "./MessageAttachment";

type NotificationItemProps = {
    Messages : APIStore.MessageState,
    FocusPatient : APIStore.FocusPatientState,
    Patients : APIStore.PatientState,
    apiHost: string

    
} & typeof APIStore.actionCreators & RouteComponentProps<{ MessageId: string }>;


const formatDate = (date : any) => {
    return moment(date).format("hh:mm:ss A MM-DD-YYYY");
}


const findErrorsForMessage = (messageId: number, Errors: APIStore.MessageStateError[]) => {
    let errors = Errors.filter(val => val.messageId === messageId);
    if (errors.length) {
        return errors[0];
    }
}

const MessageIsAdmitNotification = (message: APIStore.Message) => {
    if(!message) {
        return false;
    }
    if (message.description === 'admit') {
        return true;
    }

    return false;
}

const MessageIsDischargeNotification = (message: APIStore.Message) => {
    if(!message) {
        return false;
    }
    if (message.description === 'discharge') {
        return true;
    }

    return false;
}

const messageIsSystemNotification = (message: APIStore.Message) => {
    if (MessageIsAdmitNotification(message) || MessageIsDischargeNotification(message)) {
        return true;
    }

    return false;
}

const formatSender = (sender : string) => {
    // format physician names
    // potentially display phone
    // properly display VitalsMD symbol

    if (sender === 'RefMD') {
        return 'System'
    }

    return sender;
}

const NotifcationItem = (props: NotificationItemProps) => {
    let { Messages, archiveMessage, apiHost, requestProviderMessage, markMessageAsRead, clearSentMessageState, requestConsolidatedPatientById, FocusPatient } = props;
    let { Errors, SendMessageState, FocusMessage, failedLoading }: APIStore.MessageState = Messages;
    let [tokenState, setTokenState] = useState<APIStore.TokenType>();
    let [readNotification, setReadNotification] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);


    let initial: DetailedPatientStateType = {
        patient: undefined,
        isLoaded: false,
        isLoading: false
    };

    let [detailedPatientState, setDetailedPatientState] = useState<DetailedPatientStateType>(initial);

    let Patients = props.Patients;


    let messageId = parseInt(props.match.params.MessageId) || 0;

    const handleClickListItem = () => {
        setDeleteDialogOpen(true);
    };

    let tokenStatePr = RequestAccessToken()
        .then((token) => {
            if (token && !tokenState) {
                setTokenState(token);
            }
        });

    useEffect(() => {
        if (tokenState && tokenState.accessToken) {
            requestProviderMessage(tokenState.accessToken, messageId);
        }
    }, [tokenState, messageId]);

    useEffect(() => {
        if (FocusMessage?.messageId) {
            let patientEncounterId = FocusMessage.message?.ptId;
            if (tokenState?.accessToken && !detailedPatientState?.isLoaded && !detailedPatientState.isLoading) {
                requestConsolidatedPatientById(patientEncounterId, tokenState.accessToken);
                setDetailedPatientState({
                    ...detailedPatientState,
                    isLoading: true
                })
            }


            if (detailedPatientState.isLoading) {
                if (FocusPatient?.patient?.patientEncounterId) {
                    setDetailedPatientState({ isLoaded: true, isLoading: false, patient: FocusPatient?.patient })
                }
            }
        }

    }, [tokenState, detailedPatientState, Patients.fullPatients, FocusMessage]);

    let fullMessage = FocusMessage?.message;

    if (!FocusMessage || !FocusMessage.message) {
        return <React.Fragment></React.Fragment>;
    }

    if (FocusMessage.isErrored) {
        return <React.Fragment></React.Fragment>;
    }

    let isSent, message, isErrored = null;
    let messageSent = false;
    let sentMessage = '';
    if (SendMessageState) {
        let { isSent, message, isErrored } = SendMessageState;
        messageSent = isSent;
        sentMessage = message;
    }

    let generalErrorMessage = '';
    if (Errors && Errors.length) {
        let generalError = Errors.filter(val => val.messageId < 1)[0];
        generalErrorMessage = generalError.error;
    }

    const handleClose = () => {
        if(fullMessage && tokenState) {
            archiveMessage(fullMessage, tokenState.accessToken);
            setDeleteDialogOpen(false);
            history.goBack();
        }
    };

    const handleCloseSnack = () => {
        debugger;
        isSent = false;
        messageSent = false;
        sentMessageSubject = '';
        clearSentMessageState();
    }

    const history = useHistory();
    const reply = () => {
        history.push("/notification-reply", { message: fullMessage });
    };
    const goBack = () => {
        history.goBack();
    };

    if (FocusMessage.isLoading || !detailedPatientState?.isLoaded ) {
        return (

            <div className="maincontent">
                <Paper elevation={1} style={{ padding: 50 }}>

                    <Grid container spacing={8} className="noticebar"
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        <Grid item>
                            <Button startIcon={< Reply />} disabled={true}>
                                <Hidden xsDown>
                                    Reply
                                </Hidden>
                            </Button>
                            <Button startIcon={< Delete />} disabled={true}>
                                <Hidden xsDown>
                                    Delete
                                </Hidden>
                            </Button>
                            <Button startIcon={< Cancel />} disabled={true}>
                                <Hidden xsDown>
                                    Cancel
                                </Hidden>
                            </Button>
                        </Grid>
                    </Grid>
                    <Box m={4}>
                        <Grid container direction="row" spacing={4}>
                            <Grid item xs={4}>
                                <div className="animate-flicker"><p className="skeleton">&#8239;&#8239;&#8239;&#8239;</p></div>
                                <div className="animate-flicker"><p className="skeleton">&#8239;&#8239;&#8239;&#8239;</p></div>
                            </Grid>

                        </Grid>
                        <Grid item xs={12}>
                            <p className="animate-flicker">Loading...</p>
                        </Grid>
                    </Box>

                </Paper>
            </div>
        )
    }

    if (FocusMessage.isErrored) {
        return (<React.Fragment>
            <div className="maincontent">
                <Paper elevation={1} style={{ padding: 50 }}>
                    <Grid container spacing={8} className="noticebar"
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        <Grid item>
                            <Button startIcon={< Reply />} disabled={true}>
                                <Hidden xsDown>
                                    Reply
                                </Hidden>
                            </Button>
                            <Button startIcon={< Delete />} disabled={true}>
                                <Hidden xsDown>
                                    Delete
                                </Hidden>
                            </Button>
                            <Button startIcon={< Cancel />} disabled={true}>
                                <Hidden xsDown>
                                    Cancel
                                </Hidden>
                            </Button>
                        </Grid>
                    </Grid>
                    <Box m={4}>
                        <Grid container direction="row" spacing={4}>
                            <Grid item xs={12}>
                                <div>From: N/A</div>
                                <div>Subject: <strong>N/A</strong></div>
                                <div>Date: <strong>N/A</strong></div>
                            </Grid>

                        </Grid>
                        <Grid item xs={12}>
                            {FocusMessage.errorMessage}
                        </Grid>
                    </Box>
                </Paper>
            </div>
        </React.Fragment>)
    }


    let statusStr = '';
    let error = APIStore.findMessage(fullMessage.messageId, Errors);
    if (error) {
        statusStr = `Error ${error.error}`;
    }

    if (SendMessageState && SendMessageState.isSent) {
        statusStr = `Message Sent '${SendMessageState.message.subject}''`
    }

    if (tokenState && tokenState.accessToken && !readNotification) {
        markMessageAsRead(tokenState.accessToken, fullMessage);
        setReadNotification(true);
    }


    let sentMessageSubject = '';
    if (sentMessage && sentMessage.subject) {
        sentMessageSubject = sentMessage.subject;
    }



    return (
        <React.Fragment>
            <Slide in timeout={1000} direction="left">
                <div className="maincontent">
                        <ConfirmDialog
                            id="delete-notificaiton-item"
                            keepMounted
                            open={deleteDialogOpen}
                            onClose={handleClose}
                            question="Are you sure you want to Delete?"
                            title="Confirm Delete"
                        />
                        <Grid container spacing={12} className="noticebar"
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="center"
                        >
                            <Grid item>
                                <Button startIcon={< Reply />} disabled={messageIsSystemNotification(fullMessage)} onClick={() => reply()}>
                                    <Hidden xsDown>
                                        Reply
                                    </Hidden>
                                </Button>
                                <Button startIcon={< Delete />} disabled={messageIsSystemNotification(fullMessage)} onClick={() => setDeleteDialogOpen(true)}>
                                    <Hidden xsDown>
                                        Delete
                                    </Hidden>
                                </Button>
                                <Button startIcon={< Cancel />} onClick={goBack}>
                                    <Hidden xsDown>
                                        Cancel
                                    </Hidden>
                                </Button>
                            </Grid>
                        </Grid>
                        <Box m={4}>
                            <Grid container direction="row" spacing={4}>
                                <Grid item xs={12}>
                                    <div>From: <strong>{formatSender(fullMessage.senderId, fullMessage.type)}</strong></div>
                                    <div>Subject: <strong>{fullMessage.subject}</strong></div>
                                    <div>Date: <strong>{formatDate(fullMessage.createdDate)}</strong></div>
                                    <br />
                                    <NotificationPatient message={fullMessage} />
                                </Grid>
                                <Grid item xs={12}>
                                    {fullMessage.message}
                                </Grid>
                                <Grid item xs={12}>
                                    <div className="messagedialog">{statusStr}</div>
                                </Grid>
                                <Grid item xs={12}>

                                </Grid>
                            </Grid>
                        </Box>
                        <Box m={4}>
                            <MessageAttachment
                                documentFileName={fullMessage.documentFileName}
                                document={fullMessage.document}
                                documentId={fullMessage.documentId}
                                apiHost={apiHost}
                            >

                            </MessageAttachment>
                        </Box>
     

                    <Snackbar
                        className='red-snackbar'
                        message={`Error loading messages: ${generalErrorMessage}`}

                        open={failedLoading}
                        action={
                            <React.Fragment>
                                <Button color="secondary" size="small" onClick={handleClose}>
                                    CLOSE
                                </Button>
                                <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                                    <ErrorIcon fontSize="small" />
                                </IconButton>
                            </React.Fragment>
                        } />

                    <Snackbar
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }} autoHideDuration={6000}

                        action={
                            <React.Fragment>
                                <Button color="secondary" size="small" onClick={() => handleCloseSnack()}>
                                    CLOSE
                                </Button>
                                <IconButton size="small" aria-label="close" color="inherit" onClick={() =>handleCloseSnack()}>
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            </React.Fragment>
                        }

                        open={messageSent && !isErrored} message={`Message Sent: ${sentMessageSubject}`
                        } />
                </div>
            </Slide>
        </React.Fragment>
    );
};

export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(NotifcationItem as any);
